import { defineAction } from '~/prix'
import { z } from 'zod'
import expression from '~/prix/types/expression'
import { enumerated } from '~/prix/types/enumerated'
import materialDeliveryImageListAction from './materialDeliveryImageList.action.json' with { type: 'json' }
import { materialDeliveryImageObject } from '../materialDeliveryImageObject'

export const materialDeliveryImageExpression = expression(materialDeliveryImageObject.shape)

const materialDeliveryImageListDefinition = defineAction({
  ...materialDeliveryImageListAction,
  input: z.object({
    filter: materialDeliveryImageExpression.nullish(),
    limit: z.number().min(1).max(5000).nullish(),
    offset: z.number().nullish(),
    orderBy: enumerated({
      createdAt: 'Data de criação',
      updatedAt: 'Data de atualização',
      position: 'Posição',
    }).nullish(),
    order: enumerated({
      ascending: 'Ascendente',
      descending: 'Descendente',
    }).nullish(),
    includeDeleted: z.boolean().nullish(),
  }),
  output: z.object({
    items: z.array(materialDeliveryImageObject),
    count: z.number(),
  }),
})

export default materialDeliveryImageListDefinition
